import { post, get } from '../../../../services/request';

//-------------------Miscellaneous Site Data - start----------------//
// Get all miscellaneous site data
export const getAllMiscSiteData = (payload) => {
    const { fromDate, toDate, showUnAssigned } = payload || {};
    
    if (!fromDate || !toDate) {
        throw new Error('FromDate and ToDate are required for getAllMiscSiteData');
    }
    
    return get(`ExamData/GetAllMiscSitesList?FromDate=${fromDate}&ToDate=${toDate}&ShowUnAssigned=${showUnAssigned}`);
};

// Get all sites dropdown list for Parent Site selection
export const getAllSitesDropdown = () => {
    return get(`SiteManagement/GetAllSitesDropDownList?loadAllSites=false`);
};

// Get practice site mapping by site ID
export const getPracticeSiteMappingBySiteID = (siteID) => {
    if (!siteID) {
        throw new Error('SiteID is required for getPracticeSiteMappingBySiteID');
    }
    return get(`PracticeSite/GetPracticeSiteMappingBySiteID?SiteID=${siteID}`);
};

// Save/Update miscellaneous sites list
export const saveUpdateMiscSitesList = (payload) => {
    return post(`ExamData/SaveUpdateMiscSitesList`, payload);
};
//-------------------Miscellaneous Site Data - end----------------//